import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    dataItem: {
      id: null,
    },
    requestResult: {
      code: null,
      result: null,
      message: null,
      valuation: null,
    },
  },
  getters: {
    dataItem(state) {
      return state.dataItem
    },
    requestResult(state) {
      return state.requestResult
    },
  },
  mutations: {
    SET_RESULT(state, data) {
      state.requestResult = data
    },
    RESET_STORE(state) {
      state.dataItem = {
        id: null,
      }
      state.requestResult = {
        code: null,
        result: null,
        message: null,
        valuation: null,
      }
    },
  },
  actions: {
    getValuation({ commit }, id) {
      return axiosIns
        .post('/ExpertisePortal/indicata', { id })
        .then(response => {
          commit('SET_RESULT', response.data.result)
          return response.data.result
        })
        .catch(error => console.error(error))
    },
  },
}
